import React from 'react'
import type { NavigationContainerRef } from '@react-navigation/core'

import { STACK_SIDE_MENUS, ANALYTICS_NAME_MAP } from 'APP/Nav/Constants'
import { navigationRef } from 'APP/Nav/Provider'
import { RouteName, TypedRoute } from 'APP/Nav/types'

export const selectDescriptorOfCurrentRoute = (
  descriptors: Record<string, { options: Record<string, unknown> }> = {},
  stackRoutes: TypedRoute[] = []
) => {
  const route = stackRoutes[stackRoutes.length - 1]
  return descriptors[route?.key]
}

export const isAtFirstRoute = (nav: { canGoBack(): boolean }) => {
  if (!navigationRef.isReady()) return false
  return !nav.canGoBack()
}

export const createScreenFocusTracker = (
  navigationRef: NavigationContainerRef<ReactNavigation.RootParamList>,
  {
    focus,
    blur,
  }: {
    focus?: (route: TypedRoute | undefined) => void
    blur?: (route: TypedRoute | undefined) => void
  }
) => {
  let prevRoute: TypedRoute | undefined = undefined
  return () => {
    const currentRoute = navigationRef.getCurrentRoute() as TypedRoute | undefined
    if (prevRoute !== currentRoute) {
      typeof focus === 'function' && focus(currentRoute)
      typeof blur === 'function' && prevRoute && blur(prevRoute)
    }
    prevRoute = currentRoute
  }
}

export const routeNameToAnalyticsName = (name: RouteName | undefined): string | undefined =>
  name ? ANALYTICS_NAME_MAP[name] || name : undefined

export const routesToStackSideMenus = (stackRoutes: TypedRoute[] = []) =>
  stackRoutes
    .map(({ name, key }, stackIndex) => {
      const Menu = STACK_SIDE_MENUS[name]
      return Menu && <Menu key={key} {...{ stackRoutes, stackIndex }} />
    })
    .filter((item) => !!item)

// Map of route parameters to keep in the context.
// The values are the keys that should be used in the context.
const DD_VIEW_CONTEXT_PARAM_MAP = new Map([
  ['channelId', 'episode_id'],
  ['episodeId', 'episode_id'],
  ['videoSessionId', 'video_call_session_id'],
])

export const getDdViewContext = (
  routeParams: ReactNavigation.RootParamList[RouteName]
): Record<string, unknown> => {
  const context: Record<string, unknown> = {}
  if (!routeParams) return context

  for (const [paramKey, value] of Object.entries(routeParams)) {
    const contextKey = DD_VIEW_CONTEXT_PARAM_MAP.get(paramKey)
    if (contextKey) {
      context[contextKey] = value
    }
  }

  return context
}
